import { Component, OnInit } from '@angular/core';
import { TealiumUtagService } from '@prcins/utils';
import { PAYMENT_ID, PAYMENT_AMOUNT, CURRENT_POLICY, SAVED_WALLET, SAVE_WALLET_ERROR, PAYMENT_SOURCE } from '@prcins/constants';
import { PaymentProviderService } from '../services/payment-provider.service';
import { USER_ID } from '@prcins/constants';

@Component({
  selector: 'prcins-payment-confirmation',
  templateUrl: './payment-confirmation.component.html',
  styleUrls: ['./payment-confirmation.component.css']
})
export class PaymentConfirmationComponent implements OnInit {
  paymentAmount: string;
  paymentId: string;
  helpPhone:string;
  policyNumber;
  isDisable = false;
  showMobileRegistration = true;
  savedWallet: string;
  saveWalletError: string;
  isEService: boolean;

  constructor(private uTagService: TealiumUtagService, private paymentProvider: PaymentProviderService) {

  }
  ngOnInit() {
    this.paymentId = sessionStorage.getItem(PAYMENT_ID);
    this.policyNumber = sessionStorage.getItem(CURRENT_POLICY);
    this.uTagService.view({ "event_name": this.paymentId ? 'payment_successful:' + this.paymentId : null });    
    
    this.paymentAmount = sessionStorage.getItem(PAYMENT_AMOUNT);
    this.helpPhone = sessionStorage.getItem("general-phone");
    if(this.policyNumber.toUpperCase().startsWith("COV")) {
      this.helpPhone = "800-437-5556";
    }
    this.paymentProvider
      .getPayloadForRegistration(this.policyNumber).subscribe( (resp: any) => {
        const {
          statusCode
        } = resp.policySearchInfo;
        const payplan = resp.billingDetails.payplan;
        const payplanToShow = !payplan.includes('PAYROLL') && !payplan.includes('PREMFIN') && !payplan.includes('MORTGAGEE');
        this.isDisable = statusCode === 'Expired' || statusCode === 'Cancelled';
        this.showMobileRegistration = this.showMobileRegistration && statusCode !== 'Cancelled' && payplanToShow;
    });
    this.paymentProvider
      .getMobileRegisteredPolicies(sessionStorage.getItem(USER_ID)).subscribe( (resp: any) => {
        const policy = resp.find( data => data.policyNumber === this.policyNumber);
        if (!policy.policyInfo.isPrime) {
          this.showMobileRegistration = false;
          return;
        }
        for (const veh of policy.inquiry.vehicles) {
          if (veh.entityCode === 'PPA' || veh.entityCode === 'MC') {
            return;
          }
        }
        this.showMobileRegistration = false;
    });
    this.savedWallet = sessionStorage.getItem(SAVED_WALLET);
    this.saveWalletError = sessionStorage.getItem(SAVE_WALLET_ERROR);
    this.isEService = !sessionStorage.getItem(PAYMENT_SOURCE) || sessionStorage.getItem(PAYMENT_SOURCE)  === 'eservice';
  }

  closePopup(){
    this.isDisable = false;
  }

  printPage() {
    window.print();
  }
}
